module.exports = __webpack_public_path__ + "img/success.0a6db8f6.svg";